/**
 * I DIDN'T WRITE IT
 * Code is moved from original betslip.js with some refactoring
 * (mostly removing global references and global events and hardcoded selectors)
 * These methods are specific for BS keyboard with all hardcoded stuff
 */

import $ from 'jquery';
import AbstractKeyboard from './AbstractKeyboard';
import FreebetModule from './FreebetModule';
import { isLargeContainer } from '~spa/Utils/ContainerSize';
import i18n from '~shared/utils/i18n';
import formatCurrency, { deLocalizeNumberString } from '~shared/utils/currencyUtils';

/**
 *
 * Betslip-Keyboard for full betslip
 */
let BetslipKeyboard = function (options) {
    AbstractKeyboard.call(this, options);
};

const activeStakeAreaClass = 'stake-selection-container--active';

BetslipKeyboard.prototype = Object.assign({}, AbstractKeyboard.prototype, {
    isVisible: false,
    userInput: '',
    numericalStakeValue: 0,
    elementActiveClass: 'fancyKeyboard-input-active',
    topOffset: 0,
    beamIndicator: '|',
    animationSpeed: 'fast',
    freeBetModuleVisible: false,
    target: 'betslip',

    init: function () {

        //map options to object in order to not rewrite more betslip code
        this.freebetModule = $(this.options.freebetSelector);
        this.keyboardView = $(this.options.viewSelector);
        this.parentComponentSelector = $('#betslip');
        this.userInput = this.options.userInput || '';
        this.beamIndicator = this.options.beamIndicator;
        this.numericalStakeValue = this.options.numericalStakeValue || 0;
        this.topOffset = this.options.topOffset || 0;
        this.keyboardView.detach();
        this.fkInitButtonHandlers();
        if (!this.isMobile) {
            this.fkInitPhyKeyHandlers();
        }
        this.i18n_stake = i18n.t('betslip.stake');
    },

    //checks if the selected label has some previous values and loads them in the userinput
    fkLoadPrevValues: function () {
        let dataValue = this.stakeLabel.data('value');
        let labelText;
        if (isNaN(dataValue) || dataValue === 0 || dataValue === '') {
            labelText = this.i18n_stake;
        } else {
            //let dataNumber = localizeNumber(dataValue.toString()).replace('\xa0', '');
            let dataNumber = formatCurrency(
                Number(dataValue).toFixed(2),
                undefined,
                undefined,
                false,
                false,
                2,
            );
            this.fkReplaceValue(dataNumber);
            labelText = dataNumber;
        }
        this.stakeLabel.text(labelText);
    },

    //initializes the button handlers
    fkInitButtonHandlers: function () {
        let self = this;
        this.parentComponentSelector.on('click tap', '.js-keyboard-button', function fancyKeyboardOnButtonTap(e) {
            e.preventDefault();
            e.stopPropagation();
            self.fkButtonTapped($(this));
        });

        this.parentComponentSelector.on('click tap', '.freebetVoucher:not(.offVoucher)', function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.fkFreebetSelected($(this));
        });

        $(document).on('click tap', '.offVoucher', function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.fkFreebetDeselectVoucher($(this));
        });
    },

    //binds the fancy keyboard to a valid selection or multiple element
    fkBindKeyboardToElement: function (element, freeBets, usedFreeBets) {
        if (typeof element !== 'undefined' && element.length) {
            let that = this;
            let showFreebetModule = false;
            if (this.boundToElement !== null) {
                this.fkUnbindKeyboard();
            }

            if (element.hasClass('selection-stake-details__stake-holder')) {
                //the selected element is a valid selection stakeLabel
                this.boundElementType = 'selection';
                this.topOffset = 85;
                this.boundToElement = element.closest('li.betslip-selections');
                showFreebetModule = !$.isEmptyObject(freeBets);
            } else if (element.hasClass('betslip-multiples__bet-type__stake')) {
                //the selected element is a valid multiple stakeLabel
                this.boundElementType = 'multiple';
                this.topOffset = 51;
                this.boundToElement = element.closest('li.betslip-multiples__bet-type');
                // show freebet module if there are free bets for this user,
                // multiple type allows free bet
                showFreebetModule = !$.isEmptyObject(freeBets) &&
                        this.boundToElement.data('freebetAvailable');
            }

            this.keyboardView.css('top', -this.topOffset);
            this.stakeLabel = element;
            this.fkLoadPrevValues();
            this.fkAttachViewToElement();
            this.fkShow(
                function () {
                    if (showFreebetModule) {
                        that.fkFreebetShowModule(freeBets, usedFreeBets, element);
                    }
                },
                this.parentComponentSelector[0] // ie the betslip element
            );
        }

        return this;
    },

    //unbinds the fancy keyboard and wipes the stored values
    fkUnbindKeyboard: function () {

        if (this.keyboardView.hasClass('keyboard-attached-to-multiple')) {
            this.keyboardView.removeClass('keyboard-attached-to-multiple');
        } else if (this.keyboardView.hasClass('keyboard-attached-to-selection')) {
            this.keyboardView.removeClass('keyboard-attached-to-selection');
        }

        this.topOffset = 0;
        this.keyboardView.css('top', this.topOffset);
        this.fkDetachViewFromElement();
        this.boundToElement = null;
        this.boundElementType = null;
        this.stakeLabel = null;
        this.numericalStakeValue = 0;
        this.userInput = '';
        this.isVisible = false;
    },

    //prepares and inserts the keyboard view after the bounded element
    fkAttachViewToElement: function () {
        this.keyboardView.addClass(`keyboard-attached-to-${this.boundElementType}`);
        this.keyboardView.insertAfter(this.boundToElement);
    },

    //prepare and detaches the keyboard view from the prev bounded element and stores it
    fkDetachViewFromElement: function () {
        this.keyboardView.removeClass(`keyboard-attached-to-${this.boundElementType}`);
        this.keyboardView.detach();
    },

    //animation to show the keyboard
    fkShow: function (cb, betslipEl) {
        if (!this.isVisible) {
            this.stakeLabel.addClass(this.elementActiveClass);
            const stakeLabelContainer = this.stakeLabel.closest('.stake-selection-container');
            stakeLabelContainer.addClass(activeStakeAreaClass);
            this.keyboardView.css('z-index', '-1');
            this.keyboardView.slideDown(this.animationSpeed)
                    .animate({'top': `+=${this.topOffset }px`}, this.animationSpeed, function () {
                        cb();
                        if (isLargeContainer()) {
                            // callback function - make sure an element is visible.
                            let ensureElVisible = function(element) {
                                let ele = $(element);
                                let footer = $('.betslip-footer');
                                let offsetY = ele.offset().top + ele.outerHeight(true) - footer.offset().top;
                                if (offsetY > 0) {
                                    $('.betslip-content').animate({scrollTop: `+=${offsetY }px`}, 200);
                                }
                            };
                            window.setTimeout(ensureElVisible(this), 0);
                        }
                    })
                    .css('display', (this.boundElementType == 'multiple') ? 'inline-block' : 'block')
                    .css('z-index', '0');
            this.isVisible = true;
        }
    },

    //animation to hide the keyboard
    fkHide: function (cb) {
        let that = this;
        if (this.isVisible) {
            const stakeLabelContainer = this.stakeLabel.closest('.stake-selection-container');
            stakeLabelContainer.removeClass(activeStakeAreaClass);
            this.keyboardView.css('z-index', '-1');

            let hideKeyboardCallback = function hideKeyboardCallback() {
                that.keyboardView.animate({'top': `-=${that.topOffset }px`}, that.animationSpeed).slideUp(that.animationSpeed, function () {
                    cb();
                });
            };

            if (this.freeBetModuleVisible) {
                this.fkFreebetHideModule(hideKeyboardCallback);
            } else {
                hideKeyboardCallback();
            }

            this.isVisible = false;
        }
    },

    //immediately hides the keyboard without any animation
    fkDisappear: function () {
        if (this.boundToElement) {
            let labelText = this.stakeLabel.text();
            if (labelText.indexOf('|') != -1) {
                labelText = labelText.slice(0, -1);
            }
            if (isNaN(parseFloat(labelText))) {
                labelText = this.i18n_stake;
            } else {
                this.stakeLabel.text(labelText);
            }
            const stakeLabelContainer = this.stakeLabel.closest('.stake-selection-container');
            stakeLabelContainer.removeClass(activeStakeAreaClass);
            this.keyboardView.css({'z-index': '-1', 'top': `-=${this.topOffset }px`});
            this.freebetModule.css({'display': 'none', 'top': '-52px'});
            this.freeBetModuleVisible = false;
            this.isVisible = false;
            this.fkUnbindKeyboard();
        }
    },

    // conveniency method to update the real numeric value for the stake
    fkUpdateNumericalStakeValue: function () {
        if (this.userInput === '' || this.userInput === 0) {
            this.numericalStakeValue = 0;
            this.stakeLabel.attr('data-value', this.numericalStakeValue);
            this.stakeLabel.data('value', this.numericalStakeValue).trigger('stakeValueChanged');
            this.stakeLabel.text(this.i18n_stake);
        } else {
            this.numericalStakeValue = Number(deLocalizeNumberString(this.userInput)).toFixed(2);
            this.stakeLabel.attr('data-value', this.numericalStakeValue);
            this.stakeLabel.data('value', this.numericalStakeValue).trigger('stakeValueChanged');
            this.stakeLabel.text(this.userInput + this.beamIndicator);
        }
    },

    // closes and unbinds the fancy keyboard
    fkDoneButtonTapped: function () {
        let that = this;
        let newLabelValue;
        if (this.numericalStakeValue === 0 || isNaN(this.numericalStakeValue)) {
            newLabelValue = this.i18n_stake;
        } else {
            newLabelValue = formatCurrency(
                Number(deLocalizeNumberString(this.userInput)).toFixed(2),
                undefined,
                undefined,
                false,
                false,
                2,
            );
        }
        this.stakeLabel.text(newLabelValue);
        this.fkHide(function () {
            that.fkUnbindKeyboard();
        });
    },

}, FreebetModule);

export default BetslipKeyboard;
